import { TimePicker } from 'antd'
import dayjs from 'dayjs'

import { ComponentController } from './component_controller'

export class TimeWithoutTimeZonePickerController extends ComponentController {
  get component() {
    return TimePicker
  }

  get initialProps() {
    const props = this.propsFromData

    let defaultValue
    if (props.defaultValue) {
      defaultValue = dayjs(props.defaultValue, 'hh:mm')
    }

    props['showToday'] = false

    return {
      allowClear: false,
      format: 'h:mm a',
      ...props,
      defaultValue,
    }
  }
}
